<template>
  <ToggleSection
    label="XYZCT Dimension Details"
    icon-classes="fa-solid fa-microscope"
    :collapsed="!dv.isEditing"
  >
    <FieldGrid
      class="form-fields"
      :fields="fieldsGrid"
      :dv="dv"
      :validation-errors="validationErrors"
    >
      <!-- z_stack: synthetic boolean toggle (not in dv.modelAttributes) -->
      <template #z_stack>
        <FieldComponent
          :field-meta="boolFieldMeta"
          :data="{ value: zStack }"
          :is-edit-mode="dv.isEditing"
          @edit="(value) => $emit('update:zStack', value)"
        />
      </template>
      <!-- z_planes: override mandatory to match zStack state -->
      <template #z_planes>
        <FieldComponent
          :field-meta="dv.modelAttributes['z_planes']"
          :data="dv.editedRecord['z_planes']"
          :is-edit-mode="dv.isEditing"
          :error-message="validationErrors['z_planes'] || ''"
          @edit="(value) => dv.edit({ name: 'z_planes' }, value)"
        />
      </template>
      <!-- timeLapse: synthetic boolean toggle (not in dv.modelAttributes) -->
      <template #timeLapse>
        <FieldComponent
          :field-meta="boolFieldMeta"
          :data="{ value: timeLapse }"
          :is-edit-mode="dv.isEditing"
          @edit="(value) => $emit('update:timeLapse', value)"
        />
      </template>
      <!-- time_points: override mandatory to match timeLapse state -->
      <template #time_points>
        <FieldComponent
          :field-meta="dv.modelAttributes['time_points']"
          :data="dv.editedRecord['time_points']"
          :is-edit-mode="dv.isEditing"
          :error-message="validationErrors['time_points'] || ''"
          @edit="(value) => dv.edit({ name: 'time_points' }, value)"
        />
      </template>
    </FieldGrid>
  </ToggleSection>
</template>

<script>
import { computed } from 'vue'
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

const BOOL_DROPDOWN_META = {
  type: 'boolean',
  default: false,
  readonly: false,
  mandatory: true,
  multiple: false,
  visible: true,
  widget: { edit: { arguments: { type: 'dropdown' } } },
  validations: [
    {
      name: 'required',
      arguments: [],
      error_message: 'This field is mandatory.',
    },
  ],
}

const BASE_FIELDS_GRID = [['x_size', 'y_size', 'pixel_size']]

export default {
  components: {
    ToggleSection,
    FieldGrid,
  },
  props: {
    dv: { type: Object, required: true },
    validationErrors: { type: Object, default: () => ({}) },
    zStack: { type: Boolean, required: true },
    timeLapse: { type: Boolean, required: true },
  },
  emits: ['update:zStack', 'update:timeLapse'],
  setup(props) {
    const fieldsGrid = computed(() => {
      const zRow = props.zStack
        ? ['z_stack', 'z_planes', 'z_step']
        : ['z_stack']
      const tRow = props.timeLapse
        ? ['timeLapse', 'time_points', 'time_step']
        : ['timeLapse']
      return [...BASE_FIELDS_GRID, zRow, tRow, ['channels']]
    })

    return {
      fieldsGrid,
      boolFieldMeta: BOOL_DROPDOWN_META,
    }
  },
}
</script>

<style lang="scss" scoped>
.field-component.has-error :deep(input),
.field-component.has-error :deep(div.multiselect__tags) {
  border-color: var(--danger);
  box-shadow: 0 0 0 0.125em var(--ring-danger);
}
</style>
